module.exports = __webpack_public_path__ + "static/media/lr.e026e0f7.svg";